import React from 'react';

const DeleteIcon = ({ width, height, opacity = null, fill, stroke = null, strokeWidth = null }) => (
    <svg
        className="icon delete-icon"
        width={width}
        height={height}
        stroke={stroke}
        strokeWidth={strokeWidth}
        viewBox="0 0 15.85368 15.937039"
    >
        <path
            fill={fill}
            d="m 9.314296,7.9816956 6.216,-6.254 a 0.994,0.994 0 1 0 -1.4,-1.40900002 l -6.22,6.25400002 -6.216,-6.25400002 A 0.994,0.994 0 0 0 0.29429601,1.7276956 l 6.21599999,6.255 -6.21999999,6.2550004 a 1,1 0 0 0 0,1.409 0.989,0.989 0 0 0 1.39999999,0 l 6.216,-6.2550004 6.216,6.2550004 a 0.989,0.989 0 0 0 1.4,0 1,1 0 0 0 0,-1.409 z"
            opacity={opacity}
        />
    </svg>
);

export default DeleteIcon;
